import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Webinar from "./Components/webinar/Webinar";
import HeroSection from "./Components/HeroSection/HeroSection";
import SolutionSection from "./Components/SolutionSection/SolutionSection";
import BenefitsSection from "./Components/BenefitsSection/BenefitsSection";
import CredentialsSection from "./Components/CredentialsSection/CredentialsSection";
import Athlete from "./Components/Athlete/Athlete";
import Bonus from "./Components/Bonus/Bonus";
import EliteAthlete from "./Components/EliteAthlete/EliteAthlete";
import WebinarCountdown from "./Components/webinarcountdown/WebinarCountdown";
import FaqSection from "./Components/Faqsection/FaqSection";
import ReactionGame from "./Components/ReactionGame/ReactionGame";
import ReactionLogin from "./Components/ReactionGame/ReactionLogin";
import HomePageV2 from "./Components/HomePageV2/HomePageV2";
import VisualAcuity from "./Components/VisualAcuity/VisualAcuity";
import Bootcamp from "./Components/Bootcamp/Bootcamp";
import Ignite from "./Components/Ignite/Ignite";
import WhyUs from "./Components/WhyUs/WhyUs";
import Benefits from "./Components/Benefits/Benefits";
import About from "./Components/About/About";
import ResultPage from "./Components/VisualAcuity/ResultPage";
import RefundPolicy from "./Components/RefundPolicy/RefundPolicy";
import TermsOfService from "./Components/Terms/TermsOfService";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import Contact from "./Components/Contact/Contact";
import ComplexReactionLogin from "./Components/ComplexReaction/ComplexReactionLogin";
import IntroductionBooklet from "./Components/About/IntroductionBooklet";
import ComplexReactionGame from "./Components/ComplexReaction/ComplexReactionGame";
import DashboardLogin from "./Components/Dashboard/DashboardLogin"; 
import Leaderboard from "./Components/Leaderboard/Leaderboard";
import SearchSpanTest from "./Components/Searchspan/SearchSpantest";
import SearchSpanGame from "./Components/Searchspan/SearchSpanGame";
import WorkingMemory from "./Components/Workingmemory/WorkingMemory";
import WorkingMemoryGame from "./Components/Workingmemory/WorkingMemoryGame";
import Admin from "./Components/Webinartest/Admin";
import Webinartest from "./Components/Webinartest/Webinar";
import Reaction from "./Components/Webinartest/Reaction";
import Anticipation from "./Components/Anticipation/Anticipation";
import AnticipationGame from "./Components/Anticipation/AnticipationGame";
import AnticipationResult from "./Components/Anticipation/AniticipationResult";
import Report from "./Components/Report/Report";
import ShortTermMemoryTest from "./Components/ShortTermMemory/ShortTermMemory";
import ShortTermMemoryGame from "./Components/ShortTermMemory/ShortTermMemoryGame";
import ColorVisionTest from "./Components/ColorVision/ColorVision";
import ColorVisionGame from "./Components/ColorVision/ColorVisionGame";
import Webinarpage from "./Components/WebinarPage/WebinarPage";
import Calibration from "./Components/Calibration/Calibration";
import ReportProcessing from "./Components/Webinartest/ReportProcessing";
import HandEyeHome from "./Components/HandEye/HandEyeCoordination";
import HandEyeSquarePlay from "./Components/HandEye/HandEyeSquarePlay";
import HandEyeCirclePlay from "./Components/HandEye/HandEyeCirclePlay";
import HandEyeLinePlay from "./Components/HandEye/HandEyeLinePlay";
import HandEyeCurvePlay from "./Components/HandEye/HandEyeCurvePlay";
import HandEyeResult from "./Components/HandEye/HandEyeResult";
import Contrast from "./Components/Contrast/Contrast";
import ContrastGame from "./Components/Contrast/ContrastGame";

import BootCampReg    from "./Components/FreeBootcamp/Bootcamp"
import VisionIgnite from "./Components/VisionIgnite/VisionIgnite";
import AdminDashboard from "./Components/Admin/AdminDashboard";
import Players from "./Components/Admin/Players";
import PlayerDetails from "./Components/Admin/PlayerDetails";
import PlayerHistory from "./Components/Admin/PlayerHistory";
import Service from "./Components/Service/Service";
 

import VisualAcuityTest from "./Components/FreeTest/VisualAcuityTest";
import VisionIgniteWebinar from "./Components/WebinarPage/VisionIgniteWebinar";

const Home = () => <HomePageV2 />;

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Login first, then play */}
        <Route path="/reactiongame" element={<ReactionLogin />} />
        <Route path="/reactiongame/play" element={<ReactionGame />} />
        
        <Route path="/visual-acuity" element={<VisualAcuity />} />
        <Route path="/visual-acuity/result" element={<ResultPage />} />
        <Route path="/bootcamp" element={<Bootcamp />} />
        
        <Route path="/ignite" element={<Ignite />} />
        <Route path="/why-us" element={<WhyUs />} />
        <Route path="/benefits" element={<Benefits />} />
        <Route path="/about" element={<About />} />
        <Route path="/intro-booklet" element={<IntroductionBooklet />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/dashboard-login" element={<DashboardLogin />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        
        <Route path="/complex-reaction" element={<ComplexReactionLogin />} />
        <Route path="/complex-reaction/play" element={<ComplexReactionGame />} />
        <Route path="/search-span" element={<SearchSpanTest />} />
        <Route path="/search-span/play" element={<SearchSpanGame />} />
        <Route path="/working-memory" element={<WorkingMemory />} />
        <Route path="/working-memory/play" element={<WorkingMemoryGame />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/reactiondemo" element={<Webinartest />} />
        <Route path="/reaction" element={<Reaction />} />
        <Route path="/anticipation" element={<Anticipation />} />
        <Route path="/anticipation/play" element={<AnticipationGame />} />
        <Route path="/anticipation/result" element={<AnticipationResult />} />
        <Route path="/short-term-memory" element={<ShortTermMemoryTest />} />
        <Route path="/short-term-memory/play" element={<ShortTermMemoryGame />} />
        <Route path="/color-vision" element={<ColorVisionTest />} />
        <Route path="/color-vision/play" element={<ColorVisionGame />} />
        <Route path="/contrast" element={<Contrast />} />
        <Route path="/contrast/play" element={<ContrastGame />} />

        {/* ================= HAND-EYE ================= */}

        <Route path="/hand-eye" element={<HandEyeHome />} />

        <Route path="/hand-eye/square" element={<HandEyeSquarePlay />} />
        <Route path="/hand-eye/circle" element={<HandEyeCirclePlay />} />
        <Route path="/hand-eye/line" element={<HandEyeLinePlay />} />
        <Route path="/hand-eye/curve" element={<HandEyeCurvePlay />} />
        <Route path="/hand-eye/result" element={<HandEyeResult />} />
        <Route path="/report" element={<Report />} />
        <Route path="/webinar" element={<Webinarpage />}/>
        <Route path="/calibration" element={<Calibration />} />
        <Route path="/report-processing" element={<ReportProcessing />} />
        <Route path="/vision-ignite" element={<VisionIgnite />} />

       
        <Route path="/admin-players" element={<Players />} />
        <Route path="/admin-playerdetails/:email" element={<PlayerDetails />} />
        <Route path="/admin-playerhistory/:email" element={<PlayerHistory />} />
        <Route path="/service" element={<Service />} />
        
        <Route path="/free-visual-acuity" element={<VisualAcuityTest />} />
        <Route path="/vision-ignite-webinar" element={<VisionIgniteWebinar />} />
      </Routes>
      <Footer />
    </Router>
  );
  
};

export default App;